import { render } from "./ChangePassword.vue?vue&type=template&id=037f0dae&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=037f0dae&lang=less&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\记录\\2508幸运28\\xingyun_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037f0dae"]])

export default __exports__